import script from "./QuestionTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionTitle.vue?vue&type=script&setup=true&lang=js"

import "@/styles/my-practice.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__